export enum VerbosityLevel {
    LOW = 'low',
    MEDIUM = 'medium',
    HIGH = 'high',
}

export const DEFAULT_HELP_PROMPT_DELAY_SECONDS = 30;

export type SignInProfile = {
    id?: string,
    language: string
    showReturnTo: boolean;
    passwordAndSso: boolean;
    maxReturnTo: number;
    verbosity: string;
    isDefault: boolean;
    isActive: boolean
    helpPromptDelaySeconds?: number;
    createdAt?: string
}